import { mapState } from 'vuex';
import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    ...mapState('watchlist', [
      'selectedOrder',
      'selectedTimespan',
      'shouldShowTimespanFilter',
    ]),
    orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName() {
      return 'market-filters-mobile-watchlist';
    },
    orderButtonTheme() {
      return this.ordersOpen ? 'dark' : 'dark';
    },
    filtersButtonTheme() {
      return this.shouldShowTimespanFilter && !this.filtersOpen ? 'dark' : 'dark';
    },
    timespansButtonTheme() {
      return this.shouldShowTimespanFilter && !this.timespansOpen ? 'dark' : 'dark';
    },
    menuClassModifier() {
      return {
        'market-filters-mobile-watchlist__menu': true,
        'market-filters-mobile-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
  },
  created() {
    this.isWatchlistOpen = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-mobile-watchlist/market-filters-mobile-watchlist.js